<template>
  <v-card>
    <!-- tab control -->
    <v-card class="d-flex justify-space-around align-center">
      <div bottom class="text-h5">Evolución de Ventas</div>
    </v-card>
    <!-- tab0 list -->
    <v-card-text>
      <v-card>
        <!-- advanced filter -->
        <v-toolbar>
          <v-autocomplete
            label="Campaña"
            :items="campaignItems"
            hide-details
            hide-no-data
            hide-selected
            item-text="code"
            item-value="url"
            v-model="selectedCampaign"
            return-object
            @change="campaignSelected($event)"
            ref="campaignAutocomplete"
            prepend-icon="mdi-close"
            @click:prepend="clearAutocomplete('campaignAutocomplete')"
          ></v-autocomplete>
          <v-spacer></v-spacer>
          <v-autocomplete
            label="Comparativa"
            :items="campaignItems"
            hide-details
            hide-no-data
            hide-selected
            item-text="code"
            item-value="url"
            v-model="selectedComparedCampaign"
            return-object
            @change="comparedCampaignSelected($event)"
            ref="ComparedCampaignAutocomplete"
            prepend-icon="mdi-close"
            @click:prepend="clearAutocomplete('ComparedCampaignAutocomplete')"
          ></v-autocomplete>
          <v-spacer></v-spacer>
          <v-autocomplete
            label="Estructura Comercial"
            :items="campaignItems"
            hide-details
            hide-no-data
            hide-selected
            item-text="code"
            item-value="url"
            v-model="selectedStructure"
            return-object
            @change="structureSelected($event)"
            ref="structureAutocomplete"
            prepend-icon="mdi-close"
            @click:prepend="clearAutocomplete('structureAutocomplete')"
          ></v-autocomplete>
          <v-spacer></v-spacer>
          <v-autocomplete
            label="Cultivo"
            :items="cropItems"
            hide-details
            hide-no-data
            hide-selected
            item-text="description"
            item-value="url"
            v-model="selectedCrop"
            return-object
            @change="cropSelected($event)"
            ref="cropAutocomplete"
            prepend-icon="mdi-close"
            @click:prepend="clearAutocomplete('cropAutocomplete')"
          ></v-autocomplete>
          <v-spacer></v-spacer>
          <v-autocomplete
            label="Vendedor"
            :items="salesmanItems"
            hide-details
            hide-no-data
            hide-selected
            item-text="description"
            item-value="url"
            v-model="selectedSalesman"
            return-object
            @change="salesmanSelected($event)"
            ref="salesmanAutocomplete"
            prepend-icon="mdi-close"
            @click:prepend="clearAutocomplete('salesmanAutocomplete')"
          ></v-autocomplete>
          <v-spacer></v-spacer>
          <v-autocomplete
            label="Distribuidor"
            :items="dealerItems"
            hide-details
            hide-no-data
            hide-selected
            item-text="name"
            item-value="url"
            v-model="selectedDealer"
            return-object
            @change="dealerSelected($event)"
            ref="dealerAutocomplete"
            prepend-icon="mdi-close"
            @click:prepend="clearAutocomplete('dealerAutocomplete')"
          ></v-autocomplete>
          <v-spacer></v-spacer>
          <v-autocomplete
            label="Categoría de Cliente"
            :items="clientCategoryItems"
            hide-details
            hide-no-data
            hide-selected
            item-text="description"
            item-value="id"
            return-object
            @change="clientCategorySelected($event)"
            ref="clientCategoryAutocomplete"
            prepend-icon="mdi-close"
            @click:prepend="clearAutocomplete('clientCategoryAutocomplete')"
          ></v-autocomplete>
        </v-toolbar>
        <!-- chart config -->
        <v-toolbar>
          <v-autocomplete
            label="Valores"
            :items="valueItems"
            hide-details
            hide-no-data
            hide-selected
            item-text="description"
            item-value="id"
            v-model="selectedValue"
            return-object
            @change="valueSelected($event)"
            ref="valueAutocomplete"
            prepend-icon="mdi-close"
            @click:prepend="clearAutocomplete('valueAutocomplete')"
          ></v-autocomplete>
          <v-spacer></v-spacer>
          <v-checkbox
            hide-details
            label="Acumular Valores"
            v-model="accumuatedValues"
            @change="accumulatedValuesChange"
          />
          <v-spacer></v-spacer>
          <v-text-field
            hide-details
            label="Meses Previos"
            @change="readDataFromAPI"
            v-model="previousMonths"
          />
          <v-spacer></v-spacer>
          <v-text-field
            hide-details
            label="Meses Posteriores"
            v-model="subsecuentMonths"
            @change="readDataFromAPI"
          />
          <v-progress-linear
            :active="loading"
            indeterminate
            absolute
            bottom
          ></v-progress-linear>
        </v-toolbar>
      </v-card>
      <!-- chart -->
      <div
        ref="chart-toolbar-container"
        class="mt-2 wdr-ui-element chart-toolbar-container"
        style="position: relative"
      >
        <div
          id="wdr-toolbar-wrapper"
          class="wdr-toolbar-ui wdr-ui-element"
          style="width: 100%;"
        >
          <ul id="wdr-toolbar">
            <div class="wdr-toolbar-group-right">
              <li id="wdr-tab-fullscreen">
                <a v-on:click.stop="enterChartFullScreen">
                  <div class="wdr-svg-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="70"
                      height="38"
                      viewBox="-17.5 774.5 36 36"
                    >
                      <title>menu_fullscreen_open</title>
                      <g fill="#555">
                        <path
                          d="M-7.5 779.976V777.5h-7v7h3v-2.752l3.758 4.067 1.74-1.846-4.342-4.003 2.844.01zM-7.742 799.096l-3.758 4.101V800.5h-3v7h7v-2h-2.618l-.049-.371 4.124-4.054-1.699-1.979zM8.746 785.913l3.754-4.092v2.679h3v-7h-7v2h2.602l.082.381-4.126 4.041 1.688 1.991zM13.5 800.5v2.598l-.382.074-4.058-4.003-1.882 1.575 4.006 3.756H8.5v3h7v-7h-2zM-4 786.5h9c1.104 0 2.5.908 2.5 2.011v7.996c0 1.103-1.396 1.993-2.5 1.993h-9c-1.104 0-2.5-.891-2.5-1.993v-8.005c0-1.103 1.396-2.002 2.5-2.002z"
                        ></path>
                      </g>
                    </svg>
                  </div>
                  <span>Pantalla completa</span>
                </a>
              </li>
            </div>
            <li id="wdr-tab-export">
              <a v-on:click.stop="exportChart">
                <div class="wdr-svg-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="36"
                    height="36"
                    viewBox="-17.5 774.5 36 36"
                  >
                    <title>menu_export</title>
                    <g fill="#555">
                      <path
                        d="M15.446 795.615l-4.289-6.461c-.346-.515-.803-.654-1.428-.654H7.788c-.186 0-.346-.029-.363.156-.008.076.017.07.059.137l4.76 7.108c.042.06.034.337-.017.38-.025.025-.067.219-.102.219H6.699c-.194 0-.354-.063-.363.125-.305 3.23-3.174 5.495-6.407 5.192-2.81-.263-5.039-2.329-5.3-5.14-.009-.195-.168-.178-.363-.178h-5.401c-.076 0-.144-.281-.144-.357 0-.025.008-.157.017-.175l4.76-7.203c.102-.16.05-.245-.109-.347-.06-.035-.118.082-.187.082h-1.94c-.616 0-1.199.145-1.553.658l-4.664 6.547c-.203.304-.545.586-.545.95v9.216c1 .911 1.267 1.646 2.187 1.629h27.625c.903.009 1.188-.709 1.188-1.611v-9.233c1-.373.157-.735-.054-1.04z"
                      ></path>
                      <path
                        d="M-3.674 783.5H-2.5v10.2c1 1.4 1.764 2.464 3.165 2.371 1.274-.083 1.835-1.097 2.835-2.371v-10.2h1.207c.346 0 .641-.04.65-.387.008-.151-.042-.193-.144-.311l-4.186-5.11c-.228-.287-.642-.302-.929-.073-.042.034-.076.081-.101.115l-4.135 5.172c-.22.271-.187.447.084.668.11.085.244-.074.38-.074z"
                      ></path>
                    </g>
                  </svg>
                </div>
                <span>Exportar</span>
              </a>
            </li>
          </ul>
        </div>
        <div id="chart-container" ref="chartcontainer"></div>
      </div>
      <!-- pibot table -->
      <div id="pivot-container" class="mt-2"></div>
    </v-card-text>
  </v-card>
</template>
<script>
/* eslint-disable */
import WebDataRocks from "webdatarocks";
import "webdatarocks/webdatarocks.min.css";
import "webdatarocks/webdatarocks.toolbar";
import "webdatarocks/webdatarocks.amcharts";
import wdrEs from "@/assets/webDataRocksEs.json";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

export default {
  name: "SalesEvolution",

  components: {
    //
  },

  data() {
    return {
      editMode: "show",
      campaignItems: [],
      cropItems: [],
      salesmanItems: [],
      clientCategoryItems: [],
      dealerItems: [],
      valueItems: [
        { id: 1, description: "Importe Contado", title: "USD Contado", prefix: "usd_contado" },
        { id: 2, description: "Importe Financiado", title: "USD Financiado", prefix: "usd_financiado" },
        { id: 3, description: "Bolsas", title: "Bolsas", prefix: "cantidad" }
      ],
      filterCampaign: null,
      filterComparedCampaign: null,
      filterStructure: null,
      filterCrop: null,
      filterSalesman: null,
      filterValue: null,
      filterClientCategory: null,
      filterDealer: null,
      selectedCampaign: null,
      selectedComparedCampaign: null,
      selectedStructure: null,
      selectedCrop: null,
      selectedValue: null,
      selectedSalesman: null,
      selectedDealer: null,
      previousMonths: 6 ,
      subsecuentMonths: 18,
      accumuatedValues: false,
      pivot: null,
      chart: null,
      title: null,
      rawData: [],
      loading: true
    };
  },

  methods: {
    async readDataFromAPI() {
      try {
        this.loading = true;
        if (
          this.filterCampaign &&
          this.filterStructure &&
          this.filterCrop &&
          this.previousMonths &&
          this.subsecuentMonths
        ) {
          if (this.chart) {
            this.chart.dispose();
          }
          this.$refs["chartcontainer"].style.height = "500px"

          let salesman_id = this.filterSalesman ? this.filterSalesman.salesman_id.toString() : "-1";
          let dealer_id = this.filterDealer ? this.filterDealer.dealer_id.toString() : "-1";
          let compared_campaign_id = this.filterComparedCampaign ? this.filterComparedCampaign.id.toString() : "0";
          let client_category_id = this.filterClientCategory ? this.filterClientCategory.id.toString() : "0";

          let endpoint =
            "/data/sales_evolution/" +
            this.filterCampaign.id.toString() +
            "/" +
            compared_campaign_id +
            "/" +
            this.filterStructure.id.toString() +
            "/" +
            this.filterCrop.id.toString() +
            "/" +
            salesman_id +
            "/" +
            dealer_id +
            "/" +
            client_category_id +
            "/" +
            this.previousMonths.toString() +
            "/" +
            this.subsecuentMonths.toString() +
            "/" +
            (this.accumuatedValues ? "1" : "0");

          let title =
            this.filterCampaign.description +
            ", Estructura Comercial: " +
            this.filterStructure.description +
            ", Cultivo: " +
            this.filterCrop.description +
            // eslint-disable-next-line
            (this.filterSalesman ? ", Vendedor: " + this.filterSalesman.description : "") +
            // eslint-disable-next-line
            (this.filterDealer ? ", Distribuidor: " + this.filterDealer.name : "") +
            // eslint-disable-next-line
            (this.filterClientCategory ? ", " + this.filterClientCategory.description.toString() : "") +
            // eslint-disable-next-line
            " (" + this.$moment().format("DD/MM/YYYY h:mm a") + ")";

          // eslint-disable-next-line
          let response = await this.$bRoot.search(endpoint);

          this.title = title;
          this.rawData = response.data;
          await this.loadPivotTable(this.rawData);
        } else {
          await this.unloadPivotTable();
        }
      } catch (error) {
        if (!this.$bRoot.errors) {
          this.$bRoot.setError(error);
        }
      } finally {
        this.loading = false;
      }
    },

    clearAutocomplete(field) {
      this.$refs[field].internalValue = [];
      switch (field) {
        case "campaignAutocomplete":
          this.filterCampaign = null;
          this.loadSalesmans();
          this.loadDealers();
          break;
        case "structureAutocomplete":
          this.filterStructure = null;
          break;
        case "ComparedCampaignAutocomplete":
          this.filterComparedCampaign = null;
          break;
        case "cropAutocomplete":
          this.filterCrop = null;
          this.loadDealers();
          break;
        case "salesmanAutocomplete":
          this.filterSalesman = null;
          break;
        case "valueAutocomplete":
          this.filterValue = null;
          break;
        case "clientCategoryAutocomplete":
          this.filterClientCategory = null;
          break;
        case "dealerAutocomplete":
          this.filterDealer = null;
          break;
      }
      this.readDataFromAPI();
    },

    campaignSelected(item) {
      this.filterCampaign = item;
      this.readDataFromAPI();
    },

    comparedCampaignSelected(item){
      this.filterComparedCampaign = item;
      this.readDataFromAPI();
    },

    structureSelected(item) {
      this.filterStructure = item;
      this.loadSalesmans();
      this.loadDealers();
      this.readDataFromAPI();
    },

    cropSelected(item) {
      this.filterCrop = item;
      this.loadDealers();
      this.readDataFromAPI();
    },

    salesmanSelected(item) {
      this.filterSalesman = item;
      this.readDataFromAPI();
    },

    async valueSelected(item) {
      this.filterValue = item;
      await this.loadPivotTable(this.rawData );
    },

    clientCategorySelected(item) {
      this.filterClientCategory = item;
      this.readDataFromAPI();
    },

    dealerSelected(item) {
      this.filterDealer = item;
      this.readDataFromAPI();
    },

    async accumulatedValuesChange() {
      this.readDataFromAPI();
    },

    async loadSalesmans() {
      this.salesmanItems = [];
      this.filterSalesman = null;
      this.selectedSalesman = null;
      let salesmans = null;
      if (this.filterStructure) {
        salesmans = await this.$bRoot.search(
          "/data/salesman_campaign_hierarchy",
          null,
          null,
          "campaign__id=" + this.filterStructure.id.toString()
        );
        this.salesmanItems = salesmans.data.results;
      }
    },

    async loadDealers() {
      this.dealerItems = [];
      this.filterDealer = null;
      this.selectedDealer = null;
      let dealers = null;
      if (this.filterStructure && this.filterCrop) {
        dealers = await this.$bRoot.search(
          "/data/dealers_campaign_crop_hierarchy" +
            "/" +
            this.filterStructure.id.toString() +
            "/" +
            this.filterCrop.id.toString(),
          null,
          null
        );
        if (dealers.data) {
          this.dealerItems = dealers.data;
        }
      }
    },

    async loadPivotTable(data) {
      let measures = [];
      let columns = [];
      let rows = [];
      let column_definition = null;

      /* configure rows*/
      rows.push({uniqueName: "periodo_codigo", caption: "Período", sort: "asc"});

      measures.push({
        uniqueName: this.filterValue.prefix + "_pedidos_campaña",
        caption: "Ventas " + this.filterValue.title + " " + this.filterCampaign.code,
        format: "f_importe"
      });
      measures.push({
        uniqueName: this.filterValue.prefix + "_entregas_campaña",
        caption: "Entregas " + this.filterValue.title + " " + this.filterCampaign.code,
        format: "f_importe"
      });
      measures.push({
        uniqueName: this.filterValue.prefix + "_pendientes_campaña",
        caption: "Pendientes " + this.filterValue.title + " " + this.filterCampaign.code,
        format: "f_importe"
      });
      measures.push({
        uniqueName: this.filterValue.prefix + "_facturacion_campaña",
        caption: "Facturación " + this.filterValue.title + " " + this.filterCampaign.code,
        format: "f_importe"
      });
      measures.push({
        uniqueName: this.filterValue.prefix + "_cobranza_campaña",
        caption: "Cobranza " + this.filterValue.title + " " + this.filterCampaign.code,
        format: "f_importe"
      });

      //Campaña Comparada
      if (this.filterComparedCampaign) {
        measures.push({
          uniqueName: this.filterValue.prefix + "_pedidos_comparada",
          caption: "Ventas " + this.filterValue.title + " " + this.filterComparedCampaign.code,
          format: "f_importe"
        });
        measures.push({
          uniqueName: this.filterValue.prefix + "_entregas_comparada",
          caption: "Entregas " + this.filterValue.title + " " + this.filterComparedCampaign.code,
          format: "f_importe"
        });
        measures.push({
          uniqueName: this.filterValue.prefix + "_pendientes_comparada",
          caption: "Pendientes " + this.filterValue.title + " " + this.filterComparedCampaign.code,
          format: "f_importe"
        });
        measures.push({
          uniqueName: this.filterValue.prefix + "_facturacion_comparada",
          caption: "Facturación " + this.filterValue.title + " " + this.filterComparedCampaign.code,
          format: "f_importe"
        });
        measures.push({
          uniqueName: this.filterValue.prefix + "_cobranza_comparada",
          caption: "Cobranza " + this.filterValue.title + " " + this.filterComparedCampaign.code,
          format: "f_importe"
        });
      }

      /* configure columns */
      columns.push({ uniqueName: "Measures" });

      /* Column definition */
      column_definition = {
        periodo_codigo: { type: "string" },

        cantidad_pedidos_campaña:  { type: "number" },
        usd_contado_pedidos_campaña: { type: "number" },
        usd_financiado_pedidos_campaña: { type: "number" },

        cantidad_entregas_campaña: { type: "number" },
        usd_contado_entregas_campaña: { type: "number" },
        usd_financiado_entregas_campaña: { type: "number" },

        cantidad_pendientes_campaña: { type: "number" },
        usd_contado_pendientes_campaña: { type: "number" },
        usd_financiado_pendientes_campaña: { type: "number" },

        cantidad_facturacion_campaña: { type: "number" },
        usd_contado_facturacion_campaña: { type: "number" },
        usd_financiado_facturacion_campaña: { type: "number" },

        cantidad_cobranza_campaña: { type: "number" },
        usd_contado_cobranza_campaña: { type: "number" },
        usd_financiado_cobranza_campaña: { type: "number" },

        cantidad_pedidos_comparada:  { type: "number" },
        usd_contado_pedidos_comparada: { type: "number" },
        usd_financiado_pedidos_comparada: { type: "number" },

        cantidad_entregas_comparada: { type: "number" },
        usd_contado_entregas_comparada: { type: "number" },
        usd_financiado_entregas_comparada: { type: "number" },

        cantidad_pendientes_comparada: { type: "number" },
        usd_contado_pendientes_comparada: { type: "number" },
        usd_financiado_pendientes_comparada: { type: "number" },

        cantidad_facturacion_comparada: { type: "number" },
        usd_contado_facturacion_comparada: { type: "number" },
        usd_financiado_facturacion_comparada: { type: "number" },

        cantidad_cobranza_comparada: { type: "number" },
        usd_contado_cobranza_comparada: { type: "number" },
        usd_financiado_cobranza_comparada: { type: "number" }
      }
     data.unshift(column_definition);

      /*Create Pivot Table*/
      this.pivot = new WebDataRocks({
        container: "#pivot-container",
        toolbar: true,
        beforetoolbarcreated: this.customizeToolbar,
        reportcomplete: this.createChart,
        global: {
          localization: wdrEs
        },
        report: {
          options: {
            showAggregationLabels: false,
            grid: {
              type: "classic",
              showHeaders: false,
              showTotals: "off",
              showGrandTotals: (this.accumuatedValues ? "off" : "on"),
              title: this.title,
              showHierarchyCaptions: true
            },
            configuratorButton: false
          },
          dataSource: {
            data: data
          },
          slice: {
            rows: rows,
            columns: columns,
            measures: measures,
            expands: {
              expandAll: true
            },
          },
          formats: [
            {
              name: "f_importe",
              thousandsSeparator: ".",
              decimalSeparator: ",",
              decimalPlaces: 2,
              currencySymbol: "",
              currencySymbolAlign: "left",
              nullValue: "",
              textAlign: "right",
              isPercent: false
            },
            {
              name: "f_valor",
              thousandsSeparator: ".",
              decimalPlaces: 0,
              currencySymbol: "",
              currencySymbolAlign: "left",
              nullValue: "",
              textAlign: "right",
              isPercent: false
            },
            {
              name: "f_porcentaje",
              thousandsSeparator: ".",
              decimalPlaces: 2,
              decimalSeparator: ",",
              currencySymbol: "",
              currencySymbolAlign: "left",
              nullValue: "",
              textAlign: "right",
              isPercent: true
            }
          ],
        }
      });
    },

    customizeToolbar(toolbar) {
      var tabs = toolbar.getTabs();
      tabs.forEach((tab, index) => {
        if (!(tab.id == "wdr-tab-fullscreen" || tab.id == "wdr-tab-export")) {
          delete tabs[index];
        }
      });
      toolbar.getTabs = function() {
        return tabs;
      };
    },

    async unloadPivotTable() {
      this.pivot = null;
    },

    createChart() {
      this.pivot.amcharts.getData({}, this.drawChart, this.updateChart);
    },

    async updateChart(chartData, rawData) {
      if (this.chart) {
        await this.chart.dispose();
      }
      this.drawChart(chartData, rawData);
    },

    drawChart(chartData, rawData) {
      //Crear Chart
      am4core.useTheme(am4themes_animated);
      this.chart = am4core.create("chart-container", am4charts.XYChart);

      // colores para series, en dos gamas, de 5 series cada una
      this.chart.colors.list = [
        am4core.color("#027600"),
        am4core.color("#002689"),
        am4core.color("#820000"),
        am4core.color("#868900"),
        am4core.color("#008889"),

        am4core.color("#78ff76"),
        am4core.color("#89aaff"),
        am4core.color("#ff0c0c"),
        am4core.color("#ebf817"),
        am4core.color("#13fdff")
      ];

      //sin subtotales rawData devuelve el doble de los registros??
      let dataLen = parseInt(this.previousMonths) + parseInt(this.subsecuentMonths) + 12
      this.chart.data = chartData.data.slice(0, dataLen);

      //Configurar Título, formáto de números y leyendas
      let title = this.chart.titles.create();
      title.text = this.title;
      title.fontSize = 18;
      title.marginBottom = 30;
      this.chart.numberFormatter.numberFormat = "#.0a";
      this.chart.legend = new am4charts.Legend();

      //Configuración de Eje Y tipo Valores
      let valueAxis = this.chart.yAxes.push(new am4charts.ValueAxis());
      switch (this.filterValue.id) {
        case 1:
          valueAxis.title.text = "USD Contado";
          break;
        case 2:
          valueAxis.title.text = "USD Financiado";
          break
        default:
          valueAxis.title.text = "Bolsas";
          break;
      }

      //Configuración de Eje x tipo Fechas
      let xAxis = this.chart.xAxes.push(new am4charts.DateAxis());
      let xTitle = "";
      if (this.filterComparedCampaign) {
        xTitle =
          " -" +
          this.previousMonths.toString() +
          " a +"  +
          this.subsecuentMonths.toString() +
          " meses, (Año base " +
          this.filterCampaign.code +
          ")";
      } else {
        xTitle =
          " -" +
          this.previousMonths.toString() +
          " a +"  +
          this.subsecuentMonths.toString() +
          " meses";
      }
      xAxis.title.text = xTitle;
      xAxis.dataFields.category = this.pivot.amcharts.getCategoryName(rawData);
      xAxis.baseInterval = {
        "timeUnit": "month",
          "count": 1
      };
      xAxis.gridIntervals.setAll([
        { timeUnit: "month", count: 1 }
      ]);
      xAxis.periodChangeDateFormats.setKey("month", "[bold]yyyy[/]");

      //Configurar Series
      for (
        let s = 0;
        s <  this.pivot.amcharts.getNumberOfMeasures(rawData);
        s++
      ) {
        this.createLineSerie(
          this.pivot.amcharts.getMeasureNameByIndex(rawData, s),
          this.pivot.amcharts.getCategoryName(rawData),
          true,
            (
            this.pivot.amcharts.getMeasureNameByIndex(rawData, s).includes("Ventas") ||
            this.pivot.amcharts.getMeasureNameByIndex(rawData, s).includes("Entregas") ||
            this.pivot.amcharts.getMeasureNameByIndex(rawData, s).includes("Cobranza")
            ? false : true
            )
        )
      }

      //Cursor
      this.chart.cursor = new am4charts.XYCursor();
    },

    createLineSerie(valueField, categoryField, bullets, hidden) {
      let series = this.chart.series.push(new am4charts.LineSeries());
      //category|date|duration|value X|Y deben coincidir con las definiciones de los ejes
      series.dataFields.dateX = categoryField;
      series.dataFields.valueY = valueField;
      series.hidden = hidden;
      series.name = valueField;
      series.strokeWidth = 2;
      series.tooltipText = "{dateX}: {valueY}";

      if (bullets) {
        let bullet = series.bullets.push(new am4charts.CircleBullet());
        bullet.circle.stroke = am4core.color("#fff");
        bullet.circle.strokeWidth = 2;
      }
    },

    enterChartFullScreen() {
      let element = this.$refs["chart-toolbar-container"];
      if (
        element.requestFullscreen ||
        element.webkitRequestFullScreen ||
        element.mozRequestFullScreen ||
        element.msRequestFullscreen
      ) {
        if (element.requestFullscreen) {
          element.requestFullscreen();
        } else if (element.webkitRequestFullScreen) {
          element.webkitRequestFullScreen();
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen();
        } else if (element.msRequestFullscreen) {
          element.msRequestFullscreen();
        }
      }
    },

     exportChart() {
      Promise.all([
        this.chart.exporting.pdfmake,
        this.chart.exporting.getImage("png")
      ])
        .then(res => {
          let pdfMake = res[0];
          let doc = {
            pageSize: "A4",
            pageOrientation: "portrait",
            pageMargins: [30, 30, 30, 30],
            content: []
          };
          doc.content.push({
            image: res[1],
            width: 530
          });
          pdfMake.createPdf(doc).download("grafico.pdf");
        })
        .catch(error => {
          if (!this.$bRoot.errors) {
            this.$bRoot.setError(error);
          }
        });
    },
  },

  async mounted() {
    var main_container = document.getElementById("app");
    main_container.classList.remove("home");

    this.current_level = this.$bRoot.auth.current_level;
    let campaigns = null,
      crops = null,
      index = -1;

    try {
      //load campaigns
      campaigns = await this.$bRoot.search("/data/campaigns", null, "-code");
      this.campaignItems = campaigns.data.results;

      //set default
      let defaultCampaignId = this.$bRoot.getUserParam("defaultCampaignId");
      index = this.campaignItems.findIndex(item => item.id == defaultCampaignId);
      if (index == -1) {
        index = this.campaignItems.findIndex(item => item.current === true);
      }
      if (index !== -1) {
        this.selectedCampaign = this.campaignItems[index].url;
        this.filterCampaign = this.campaignItems[index];
        this.selectedStructure = this.campaignItems[index].url;
        this.filterStructure = this.campaignItems[index];
      }

      //load crops
      crops = await this.$bRoot.search("/data/crops", null, "description");
      this.cropItems = crops.data.results;

      //set default
      let defaultCropId = this.$bRoot.getUserParam("defaultCropId");
      index = this.cropItems.findIndex(item => item.id === defaultCropId);
      if (index !== -1) {
        this.selectedCrop = this.cropItems[index].url;
        this.filterCrop = this.cropItems[index];
      }

      //commercial persons
      let commercialPersons = await this.$bRoot.searchAll(
        "/data/commercial_persons_hierarchy",
        null,
        "name"
      );
      this.commercialPersonItems = commercialPersons;

      /*Client Categories*/
      let clientCategories = await this.$bRoot.searchAll(
        "/data/categories",
        null,
        "description"
      );
      this.clientCategoryItems = clientCategories;

      //default value
      this.selectedValue = 1;
      this.filterValue = this.valueItems[0];

      //Salesmans and Dealers
      await this.loadSalesmans();
      await this.loadDealers();

      this.readDataFromAPI();
    } catch (error) {
      if (!this.$bRoot.errors) {
        this.$bRoot.setError(error);
      }
    } finally {
      this.loading = false;
    }
  },

  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose();
    }
  }
};
</script>
<style>
.wdr-credits {
  display: none;
}
.chart-toolbar-container:fullscreen {
  background-color: #ffffff;
  overflow-y: auto;
}
</style>
